/**
 * 流式下载大文件（使用 File System Access API）
 * 边下载边写入磁盘，避免将整个文件加载到内存导致 OOM 或连接中断
 *
 * 下载过程中如遇错误，会调用 writable.abort() 丢弃半成品文件，不会保留不完整数据。
 *
 * @param {string} url             - 下载请求 URL
 * @param {object} options
 * @param {string} options.token            - 认证 token
 * @param {string} options.filename         - 建议的文件名
 * @param {object[]} [options.types]        - File System Access API types 参数（可选）
 * @param {(percent: number, downloadedMB: number, totalMB: number | null) => void} [options.onProgress] - 进度回调
 * @returns {Promise<void>}
 */
export async function streamDownload(url, {token, filename, types, onProgress}) {
    const response = await fetch(url, {
        headers: {token},
    });
    if (!response.ok) {
        throw new Error(`服务器错误: ${response.status}`);
    }

    const contentLength = response.headers.get('content-length');
    const totalBytes = contentLength ? parseInt(contentLength, 10) : null;

    const fileHandle = await window.showSaveFilePicker({
        suggestedName: filename,
        ...(types ? {types} : {}),
    });
    const writable = await fileHandle.createWritable();

    const reader = response.body.getReader();
    let downloadedBytes = 0;

    try {
        let done = false;
        do {
            const result = await reader.read();
            done = result.done;
            if (!done) {
                await writable.write(result.value);
                downloadedBytes += result.value.byteLength;
                if (onProgress && totalBytes !== null) {
                    onProgress(Math.round((downloadedBytes / totalBytes) * 100), downloadedBytes / 1024 / 1024, totalBytes / 1024 / 1024);
                }
            }
        } while (!done);
        await writable.close(); // 下载完成，提交文件
    } catch (err) {
        await writable.abort(); // 出错或取消，丢弃半成品文件
        throw err;
    }
}
